import Api from '../Base'

class GetShipperCompliancesByCycleId extends Api {
  requestUrl = `/api/Cycle/${this.getParams().cycleId}/ShipperCompliances`
}

export default GetShipperCompliancesByCycleId
